import React from "react";
import OFACTable from "./OFACTable/OFACTable";

export default function OFACCard(props) {

    const { ofac_data } = props

    const hasSource = Object.keys(ofac_data?.source || {}).length > 0;

    if (!hasSource) return null;

    return (
        <div style={{width: "100%", border: '1px solid #dedede', borderRadius: '8px', padding: '16px'}}>
            <p style={{fontSize: "14px", fontWeight: "bold", margin: "0 0 16px 0", padding: 0, color: '#0b1f82'}}>
                OFAC - Match por similaridade encontrado
            </p>
            <OFACTable ofac_data={ofac_data.source} />
        </div>
    )
}